import {
    UPDATE_GPS_LOCATION, SET_LOCATION_ENABLED,
  } from "../store/types";
  
  const INITIAL_STATE = {
    location: null,
    error:false,
    locationEnabled: true
  }
export const gpsreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_GPS_LOCATION:
            return {
                ...state,
                location: action.payload && action.payload.lat? action.payload : null,
                error: action.payload && action.payload.lat? false : true
            };
        case SET_LOCATION_ENABLED:
            return { ...state, locationEnabled: action.payload, ...(action.payload === false ? { location: null, error: true } : {}) };
        default:
            return state;
    }
};
